const OrdersList = () => import('Views/orders/orders-list');
const OrdersDetail = () => import('Views/orders/orders-detail');

export default[
  { path: '/orders-list', component: OrdersList },
  { path: '/orders-detail', component: OrdersDetail },
];



// WEBPACK FOOTER //
// ./src/router/orders.js